import { useTranslation } from 'react-i18next';
import { InputAdornment } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { TextField } from '@avangard/ui/core';

import { usePageFilters, PageFiltersToolbar } from '@modules/shared/organisms';

import { SummaryLapsSchoolsListFilters } from '@modules/summary-results/hooks';

const searchIcon = <Search style={{ fontSize: 16 }} />;

const ToolbarFilters = () => {
    const { t } = useTranslation(['common']);

    const { filters, handleChange } = usePageFilters<SummaryLapsSchoolsListFilters>();

    return (
        <PageFiltersToolbar hideDrawerFilterButton>
            <TextField
                id='shortName'
                name='shortName'
                placeholder={t('common:forms.placeholder.school_name') ?? ''}
                value={filters.shortName}
                onChange={handleChange}
                InputProps={{
                    startAdornment: <InputAdornment position='start'>{searchIcon}</InputAdornment>,
                }}
            />
        </PageFiltersToolbar>
    );
};

export { ToolbarFilters };
